<template>
  <div class="e-line-chart-list__item" @click="onClick" :class="[element.__color ? `e-line-chart-list__item--color--${element.__color}` : '']">
    <div class="e-avatar size-30 e-line-chart-list__avatar">
      <img src="../../../assets/assets/bitcoin.svg">
    </div>
    <div class="d-flex flex-column">
      <b class="e-line-chart-list__asset">{{ element.asset }}</b>
      <small class="e-line-chart-list__currency eh-secondary-text">BTC</small>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';

	export default {
		name: "eb-line-chart-list-item",
    props: {
      item: {
        type: Object,
        required: true,
      }
    },
    watch: {
		  item: {
		    handler(current, preview) {
          this.element = _.clone(current, true);
        },
        deep: true,
      }
    },
    data() {
		  return {
		    element: _.clone(this.$props.item, true)
      }
    },
    methods: {
      onClick() {
        this.$emit('click');
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/lineChart/listItem.vue